module.exports = __webpack_public_path__ + "img/buenos_aires_recoleta.4f132e4a.jpg";